import { Component, inject } from '@angular/core';
import { LoggerService } from '@servicesV2/logger.service';

@Component({
  selector: 'app-auth-callback',
  template: '<div></div>',
})
export class AuthCallbackComponent {
  private readonly logger = inject(LoggerService).withContext('AuthCallbackComponent');

  constructor() {}
}
